import { SvgIcon, SxProps } from "@mui/material";
import FallbackAvatarSvg from "jsx:../../../Images/Icons/Custom/fallbackAvatar.svg";

export function AvatarFallbackIcon(props: SxProps) {
    return <SvgIcon component={FallbackAvatarSvg} inheritViewBox sx={props} />;
}
